const CAR_BRAND_LOGO_BASE_URL =
  'https://mycle.co.kr/resources/images/car/icon_car_'

export const getCarBrandLogoUrl = (brandIcon: string) =>
  `${CAR_BRAND_LOGO_BASE_URL}${brandIcon}_l.png`
